import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { MessageService } from 'primeng/api';
import { AppMenuProfile } from './app.menuprofile';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule, AppMenuProfile],
    template: `
        <ul class="layout-menu">
            <div app-menu-profile></div>
            @for (item of menu; track $index) {
                @if (!item.separator) {
                    <li app-menuitem [item]="item" [root]="true"></li>
                } @else {
                    <li class="menu-separator"></li>
                }
            }
        </ul> 
    `
})
export class AppMenu {
    exemple: any[] = [
        {
            icon: "pi pi-inbox",
            path: null,
            items: [
                {
                    label: 'Cadastros',
                    path: null,
                    items: [
                        {
                            icon: "pi pi-user",
                            label: "Clientes",
                            routerLink: ['/cadastros/clientes']
                        }
                    ],
                    icon: 'pi pi-inbox',
                }
            ],
            label: "Cadastros"
        },
    ];


    menu: any[] = [];

    constructor(
        private _authService: AuthService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.getMenu();
    }

    getMenu() {
        const menu = localStorage.getItem('user_menu');

        if (menu) {
            this.menu = this.buildPaths(JSON.parse(menu));
            return;
        };

        this._authService.getMenu().subscribe({
            next: (menu) => {
                if (!menu.result) return;

                localStorage.setItem('user_menu', JSON.stringify(menu.result));

                this.menu = this.buildPaths(menu.result);
            }, error: (err) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Ocorreu um erro ao tentar carregar o menu.',
                });
            }
        })
    }

    private buildPaths(items: any[], parentPath: string = '', isRoot: boolean = true): any[] {
        const result: any[] = [];

        (items ?? []).forEach((item, index) => {
            if (!item || item.separator) {
                result.push(item);
                return;
            }

            const path = `${parentPath}/${index}-${this.slugify(item.label)}`;

            result.push({
                ...item,
                path,
                items: item.items?.length ? this.buildPaths(item.items, path, false) : null
            });

            if (isRoot && index < items.length - 1) {
                result.push({ separator: true });
            }
        });

        return result;
    }

    private slugify(label: any): string {
        return (label ?? 'item')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '') || 'item';
    }
}
